module.exports = __webpack_public_path__ + "static/img/aqzs11.7898a6c6.jpg";